
import { ClipperLib } from './clipper_unminified';
import { Line } from './Line';
import { incRenderCount } from './initThree';
import * as THREE from 'three';

function vector2ToFPoint(p) {
    return new ClipperLib.FPoint(p.x, p.y);
}

function rotate(v, rad) {
    return new THREE.Vector2(
        v.x * Math.cos(rad) - v.y * Math.sin(rad),
        v.x * Math.sin(rad) + v.y * Math.cos(rad)
    );
}

function makeCircle(radius, N) {
    let ps = [];
    for (let i = 0; i < N; i++) {
        let rad = -Math.PI * 0.5 + i / N * Math.PI * 2;
        let x = Math.cos(rad) * radius;
        let y = Math.sin(rad) * radius + radius;
        ps.push(new THREE.Vector2(x, y));
    }
    return ps;
}

export class CurveEditor {
    static innerEach = 15; // 每一段曲线，它们内部的插入点数。也就是两个控制点之间的插入点数
    static boxSize = 10; // 控制点的盒子的宽度
    static boxSizeHalf = CurveEditor.boxSize / 2; // 盒子宽度的一半
    static hoverBoxSize = 12; // 鼠标移到控制点上方，盒子的宽度
    static hoverBoxSizeHalf = CurveEditor.hoverBoxSize / 2; // 上述宽度的一半
    // 三个符号，分别表示鼠标位于点上、曲线上以及空白处
    static POINT = Symbol();
    static LINE = Symbol();
    static NONE = Symbol();

    // 运行时用到的一些变量
    // 鼠标当前位置
    mouse_pos = new THREE.Vector2();
    // 鼠标落在什么位置，可能是控制点、曲线，或者空白处
    mouse_hit = {};
    // 鼠标拖动时的初始位置
    start_drag_pos = new THREE.Vector2();

    // 拖动对象的初始位置
    drag_target_start_pos = new THREE.Vector2();
    // 鼠标拖动的对象
    drag_vector = new THREE.Vector2();

    // 叶子部分
    static subLeafPaths = [
        [new THREE.Vector2(0, 0), new THREE.Vector2(4, 10), new THREE.Vector2(0, 20), new THREE.Vector2(-4, 10)],
        [new THREE.Vector2(0, 0), new THREE.Vector2(8, 10), new THREE.Vector2(4, 10), new THREE.Vector2(0, 20), new THREE.Vector2(-4, 10), new THREE.Vector2(-8, 10)],
        makeCircle(8, 16),
    ];

    petioleLen = 20;
    petioleRad = THREE.Math.degToRad(45);
    subLeafSegEach = 30;
    subLeafPathIndex = 0;


    constructor(canvas2d, controlPoints) {
        this.canvas2d = canvas2d;
        this.context = canvas2d.getContext("2d");
        this.updateSize();
        incRenderCount();

        // 控制点
        this.controlPoints = controlPoints || [
            new THREE.Vector2(-39, -151),
            new THREE.Vector2(-42, -90),
            new THREE.Vector2(-30, 4),
            new THREE.Vector2(5, 67),
            new THREE.Vector2(49, 111),
        ];
        this.firstPointVector = new THREE.Vector2(0, -20);
        this.controlPoints.unshift(this.controlPoints[0].clone().add(this.firstPointVector));
        this.updatePoints();
        this.makePaths();

        const editor = this;
        this.canvas2d.addEventListener("mousedown", function (e) {
            if (e.button !== 0) return;

            if (!editor.checkDbClick()) {
                if (editor.mouse_hit.type === CurveEditor.POINT) {
                    editor.startDrag();
                }
            }
            editor.draw();
            incRenderCount();
        });
        this.canvas2d.addEventListener("mousemove", function (e) {
            let bound = this.canvas2d.getBoundingClientRect();
            let x = e.clientX - bound.left;
            let y = e.clientY - bound.top;
            editor.mouse_pos.x = x - editor.centerX;
            editor.mouse_pos.y = -(y - editor.centerY);

            if (editor.is_dragging) {
                editor.doDrag();
            } else {
                editor.hitTest();
            }
            editor.draw();
            incRenderCount();
        });
        this.canvas2d.addEventListener("mouseup", function (e) {
            if (e.button !== 0) return;

            if (editor.is_dragging) {
                editor.endDrag();
            }
            editor.draw();
            incRenderCount();
        });
        // this.canvas.addEventListener("click", function(e) {
        //     e.preventDefault();
        //     e.stopPropagation();
        // });

        this.draw();
    }

    updatePoints() {
        // 直线不需要更新点
        let controlPoints = this.controlPoints;
        let curve = new THREE.SplineCurve(controlPoints);
        let totalPoints = (CurveEditor.innerEach + 1) * (controlPoints.length - 1);
        this.points = curve.getPoints(totalPoints);
        incRenderCount();
    }

    // 如果窗口的尺寸发生变化，那么就需要重新设置画布的尺寸
    updateSize() {
        this.bound = this.canvas2d.getBoundingClientRect();
        let width = Math.floor(this.bound.width * 0.5);
        let height = Math.floor(this.bound.height);
        this.canvas2d.style.width = width + "px";
        this.canvas2d.style.height = height + "px";
        this.canvas2d.width = width;
        this.canvas2d.height = height;
        this.width = this.canvas2d.width;
        this.height = this.canvas2d.height;
        this.centerX = Math.round(this.width / 2);
        this.centerY = Math.round(this.height / 2);
        console.log(this.centerX, this.centerY);
        // 设置画布的变换，这样就不用每次都给点加上中心偏移了。
        this.context.setTransform(1, 0, 0, -1, this.centerX + 0.5, this.centerY + 0.5);
    }

    setOnCurveChangeDown(handler) {
        this.onCurveChangeDown = handler;
    }

    getCurve() {
        return new THREE.SplineCurve(this.controlPoints);
    }

    getControlPoints() {
        return this.controlPoints.map(p => p.clone());
    }

    checkDbClick() {
        const dbClickPeroid = 500;
        let now = Date.now();
        if (now - this.lastClickTime < dbClickPeroid) {
            this.lastClickTime = 0;
            this.onDbClick();
            return true;
        } else {
            this.lastClickTime = now;
        }
        return false;
    }

    onDbClick() {
        console.log("xxx");
        if (this.mouse_hit.type === CurveEditor.POINT) {
            this.controlPoints.splice(this.mouse_hit.index, 1);
            this.updatePoints();
            this.makePaths();
        } else if (this.mouse_hit.type === CurveEditor.LINE) {
            let point = this.mouse_hit.point;
            this.controlPoints.splice(this.mouse_hit.index + 1, 0, point);
            this.updatePoints();
            this.makePaths();
        }
    }

    startDrag() {
        this.is_dragging = true;
        this.start_drag_pos.copy(this.mouse_pos);
        this.drag_target_start_pos.copy(this.controlPoints[this.mouse_hit.index]);
    }

    doDrag() {
        this.drag_vector.subVectors(this.mouse_pos, this.start_drag_pos);
        this.controlPoints[this.mouse_hit.index].addVectors(this.drag_target_start_pos, this.drag_vector);

        if (this.mouse_hit.index === 1) { this.controlPoints[0].addVectors(this.controlPoints[1], this.firstPointVector); }

        this.updatePoints();
        this.makePaths();

        if (this.onCurveChange) {
            this.onCurveChange();
        }
    }

    endDrag() {
        this.is_dragging = false;
        console.log(this.controlPoints);
        if (this.onCurveChangeDown) { this.onCurveChangeDown(); }
    }

    // 鼠标击中测试
    hitTest() {
        const boxSizeHalf = CurveEditor.boxSizeHalf;
        let x = this.mouse_pos.x;
        let y = this.mouse_pos.y;

        // 判断是否击中控制点
        let point_index = this.controlPoints.findIndex(p => x >= p.x - boxSizeHalf && x <= p.x + boxSizeHalf && y >= p.y - boxSizeHalf && y <= p.y + boxSizeHalf);
        if (point_index >= 1) {
            this.mouse_hit.type = CurveEditor.POINT;
            this.mouse_hit.index = point_index;
            return;
        }

        // 曲线
        const innerEach = CurveEditor.innerEach;
        let line = new Line();
        let nearestPoint = new THREE.Vector2();
        for (let i = 1; i < this.controlPoints.length - 1; i++) {
            let j = i * (innerEach + 1);
            let k = j + innerEach + 1;
            for (let l = j; l < k; l++) {
                line.set(this.points[l], this.points[l + 1]).closestPointToPoint(this.mouse_pos, true, nearestPoint);
                if (nearestPoint.distanceTo(this.mouse_pos) <= 3) {
                    this.mouse_hit.type = CurveEditor.LINE;
                    this.mouse_hit.index = i;
                    this.mouse_hit.point = nearestPoint; // 记录最近点（位于曲线上），以便双击时可以新增点。
                    return;
                }
            }
        }

        this.mouse_hit.type = CurveEditor.NONE;
        incRenderCount();
    }

    draw() {
        this.clear();
        this.drawMesh2();
        this.drawAxes();
        this.drawControlPoints();
        this.drawCurve();
        this.drawLeaf()
    }

    clear() {
        this.context.clearRect(-this.centerX - 1, -this.centerY - 1, this.width + 2, this.height + 2);
    }

    drawMesh2() {
        const cubeSize = 30;
        this.context.beginPath();
        let x = -cubeSize;
        while (x > -this.centerX) {
            this.context.moveTo(x, -this.centerY);
            this.context.lineTo(x, this.centerY);
            x -= cubeSize;
        }
        x = cubeSize;
        while (x < this.centerX) {
            this.context.moveTo(x, -this.centerY);
            this.context.lineTo(x, this.centerY);
            x += cubeSize;
        }
        let y = -cubeSize;
        while (y > -this.centerY) {
            this.context.moveTo(-this.centerX, y);
            this.context.lineTo(this.centerX, y);
            y -= cubeSize;
        }
        y = cubeSize;
        while (y < this.centerY) {
            this.context.moveTo(-this.centerX, y);
            this.context.lineTo(this.centerX, y);
            y += cubeSize;
        }
        this.context.closePath();
        this.context.lineWidth = 1;
        this.context.strokeStyle = "#ccc";
        this.context.stroke();
    }

    drawAxes() {
        this.context.beginPath();
        this.context.moveTo(0, -this.centerY);
        this.context.lineTo(0, this.centerY);
        this.context.moveTo(-this.centerX, 0);
        this.context.lineTo(this.centerX, 0);
        this.context.closePath();
        this.context.lineWidth = 1;
        this.context.strokeStyle = "#000";
        this.context.stroke();
    }

    drawControlPoints() {
        this.controlPoints.forEach((p, i) => {
            if (i === 0) {
                this.context.fillStyle = "blue";
                this.context.beginPath();
                this.context.arc(p.x, p.y, 3, 0, Math.PI * 2);
                this.context.closePath();
                this.context.fill();
            } else if (this.mouse_hit.type === CurveEditor.POINT && i === this.mouse_hit.index) {
                this.context.strokeStyle = "red";
                this.context.strokeRect(p.x - CurveEditor.hoverBoxSizeHalf, p.y - CurveEditor.hoverBoxSizeHalf, CurveEditor.hoverBoxSize, CurveEditor.hoverBoxSize);
            } else {
                this.context.fillStyle = "red";
                this.context.fillRect(p.x - CurveEditor.boxSizeHalf, p.y - CurveEditor.boxSizeHalf, CurveEditor.boxSize, CurveEditor.boxSize);
            }
        });
    }

    drawLeaf() {
        this.context.strokeStyle = "black";
        this.context.lineWidth = 1;
        const controlPoints = this.controlPoints;
        let curve = new THREE.SplineCurve(controlPoints);
        const len = this.petioleLen;
        const rad = this.petioleRad;
        const curveLen = curve.getLength();
        const segLen = this.subLeafSegEach;
        const N = Math.ceil(curveLen / segLen) - 1;
        const subLeafPath = CurveEditor.subLeafPaths[this.subLeafPathIndex];
        for (let i = 1; i < N; i++) {
            let t = i / N;
            let tangent = curve.getTangentAt(t);
            let normal1 = rotate(tangent, rad);
            let normal2 = rotate(tangent, -rad);
            let point = curve.getPointAt(t);
            this.context.beginPath();
            let endPoint1 = new THREE.Vector2(point.x + len * normal1.x, point.y + len * normal1.y);
            this.context.moveTo(endPoint1.x, endPoint1.y);
            this.context.lineTo(point.x, point.y);
            let endPoint2 = new THREE.Vector2(point.x + len * normal2.x, point.y + len * normal2.y);
            this.context.lineTo(endPoint2.x, endPoint2.y);
            this.context.stroke();
            this.context.closePath();

            this.context.beginPath();
            let path1 = subLeafPath.map(v => new THREE.Vector2(v.x * normal1.y + v.y * normal1.x + endPoint1.x, v.y * normal1.y - v.x * normal1.x + endPoint1.y));
            this.context.moveTo(path1[path1.length - 1].x, path1[path1.length - 1].y);
            for (let i = 0; i < path1.length; i++) {
                this.context.lineTo(path1[i].x, path1[i].y);
            }
            this.context.closePath();
            this.context.stroke();

            this.context.beginPath();
            let path2 = subLeafPath.map(v => new THREE.Vector2(v.x * normal2.y + v.y * normal2.x + endPoint2.x, v.y * normal2.y - v.x * normal2.x + endPoint2.y));
            this.context.moveTo(path2[path2.length - 1].x, path2[path2.length - 1].y);
            for (let i = 0; i < path2.length; i++) {
                this.context.lineTo(path2[i].x, path2[i].y);
            }
            this.context.closePath();
            this.context.stroke();

            // this.context.beginPath();
            // this.context.arc(point.x + len2 * normal1.x, point.y + len2 * normal1.y, radius, 0, Math.PI * 2);
            // this.context.stroke();
            // this.context.closePath();
            // this.context.beginPath();
            // this.context.arc(point.x + len2 * normal2.x, point.y + len2 * normal2.y, radius, 0, Math.PI * 2);
            // this.context.stroke();
            // this.context.closePath();
        }

        // 最后收尾，尖端
        const len3 = len * 0.4;
        let point = curve.getPointAt(1);
        let tangent = curve.getTangentAt(1);
        let endPoint = new THREE.Vector2(point.x + len3 * tangent.x, point.y + len3 * tangent.y);
        this.context.beginPath();
        this.context.moveTo(point.x, point.y);
        this.context.lineTo(endPoint.x, endPoint.y);
        this.context.stroke();
        this.context.closePath();

        this.context.beginPath();
        let path = subLeafPath.map(v => new THREE.Vector2(v.x * tangent.y + v.y * tangent.x + endPoint.x, v.y * tangent.y - v.x * tangent.x + endPoint.y));
        this.context.moveTo(path[path.length - 1].x, path[path.length - 1].y);
        for (let i = 0; i < path.length; i++) {
            this.context.lineTo(path[i].x, path[i].y);
        }
        this.context.closePath();
        this.context.stroke();
    }

    drawCurve() {
        const controlPoints = this.controlPoints;
        const innerEach = CurveEditor.innerEach;
        const points = this.points;
        for (let i = 0; i < controlPoints.length - 1; i++) {
            let j = i * (innerEach + 1);
            let k = j + innerEach + 2;
            if (this.mouse_hit.type === CurveEditor.LINE && this.mouse_hit.index === i) {
                this.context.strokeStyle = "red";
                this.context.lineWidth = 2;
            } else {
                this.context.strokeStyle = "blue";
                this.context.lineWidth = 1;
            }
            this.context.beginPath();
            this.context.moveTo(points[j].x, points[j].y);
            for (let l = j + 1; l < k; l++) {
                this.context.lineTo(points[l].x, points[l].y);
            }
            this.context.stroke();
            this.context.closePath();
        }
    }

    // 转换成路径并缓存
    makePaths() {
        let boneLines = [];
        boneLines.push(this.points.map(vector2ToFPoint));

        let curve = new THREE.SplineCurve(this.controlPoints);

        const len = this.petioleLen;
        const rad = this.petioleRad;
        const curveLen = curve.getLength();
        const segLen = this.subLeafSegEach;
        const N = Math.ceil(curveLen / segLen) - 1;
        const subLeafPath = CurveEditor.subLeafPaths[this.subLeafPathIndex];

        for (let i = 1; i < N; i++) {
            let t = i / N;
            let tangent = curve.getTangentAt(t);
            let normal1 = rotate(tangent, rad);
            let normal2 = rotate(tangent, -rad);
            let point = curve.getPointAt(t);
            let endPoint1 = new THREE.Vector2(point.x + len * normal1.x, point.y + len * normal1.y);
            let endPoint2 = new THREE.Vector2(point.x + len * normal2.x, point.y + len * normal2.y);
            boneLines.push([endPoint1, point, endPoint2].map(vector2ToFPoint));

            let path1 = subLeafPath.map(v => new ClipperLib.FPoint(v.x * normal1.y + v.y * normal1.x + endPoint1.x, v.y * normal1.y - v.x * normal1.x + endPoint1.y));
            path1.push(path1[0]);
            boneLines.push(path1);

            let path2 = subLeafPath.map(v => new ClipperLib.FPoint(v.x * normal2.y + v.y * normal2.x + endPoint2.x, v.y * normal2.y - v.x * normal2.x + endPoint2.y));
            path2.push(path2[0]);
            boneLines.push(path2);
        }

        // 最后收尾，尖端
        const len3 = len * 0.4;
        let point = curve.getPointAt(1);
        let tangent = curve.getTangentAt(1);
        let endPoint = new THREE.Vector2(point.x + len3 * tangent.x, point.y + len3 * tangent.y);
        boneLines[0].push(vector2ToFPoint(endPoint));

        let path = subLeafPath.map(v => new ClipperLib.FPoint(v.x * tangent.y + v.y * tangent.x + endPoint.x, v.y * tangent.y - v.x * tangent.x + endPoint.y));
        path.push(path[0]);
        boneLines.push(path);

        // 起始点：一个圆球
        const thickness = 2;
        let startPoint = this.controlPoints[0].clone();
        startPoint.y -= thickness;
        boneLines[0].unshift(vector2ToFPoint(startPoint));

        let solution = new ClipperLib.PolyTree();
        let co = new ClipperLib.ClipperOffset(2, 0.01);
        // co.AddPaths(boneLines, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etOpenRound);
        co.AddPaths(boneLines, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etOpenButt);
        co.Execute(solution, thickness);
        this.paths = {
            startPoint,
            polytree: solution
        };
    }

    toPaths() {
        return this.paths;
    }
}


// WEBPACK FOOTER //
// ./src/views/makeLeaf/scripts/CurveEditor.js